import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';
import { sv } from '@aldorock-fordon/shared/sv';
import { api } from '../api.ts';
import { usePage } from '../page.ts';
import { PageHead } from '../ui/PageHead.tsx';
import { moment } from '../format.ts';

type Message = {
  id: string;
  bookingId: string | null;
  subject: string;
  body: string;
  status: 'vantar' | 'skickad' | 'misslyckad';
  hasIcs: boolean;
  attachmentName: string | null;
  sentAt: string | null;
  createdAt: string;
};

export function MessagesPage() {
  const h1 = usePage(sv.messages.title);
  const q = useQuery({ queryKey: ['messages'], queryFn: () => api<Message[]>('/messages') });
  return (
    <>
      <PageHead help="messages" title={sv.messages.title} titleRef={h1} />
      <p>{sv.messages.intro}</p>
      {q.isPending ? <p role="status">{sv.app.loading}</p> : null}
      {q.data && q.data.length === 0 ? <p className="muted">{sv.messages.empty}</p> : null}
      {q.data?.map((m) => (
        <article className="mail" key={m.id} aria-labelledby={`m-${m.id}`}>
          <h3 id={`m-${m.id}`}>{m.subject}</h3>
          <p className="caption">
            {m.status === 'skickad'
              ? `${sv.messages.sent} ${moment(m.sentAt ?? m.createdAt)}`
              : m.status === 'vantar'
                ? sv.messages.pending
                : sv.messages.failed}
            {m.bookingId ? (
              <>
                {' · '}
                <Link to={`/bokning/${m.bookingId}`}>{sv.start.show}</Link>
              </>
            ) : null}
            {m.hasIcs ? (
              <>
                {' · '}
                <a href={`/api/v1/messages/${m.id}/ics`} download="bokning.ics">
                  {sv.ical.download}
                </a>
              </>
            ) : null}
            {m.attachmentName ? (
              <>
                {' · '}
                <a href={`/api/v1/messages/${m.id}/attachment`} download={m.attachmentName}>
                  {sv.schedules.attachment}: {m.attachmentName}
                </a>
              </>
            ) : null}
          </p>
          <pre className="mail-body">{m.body}</pre>
        </article>
      ))}
    </>
  );
}
